import React from 'react'
import { useTranslation } from 'react-i18next'
import { InputLabel } from '@node-space/storybook-components/dist/FormElements'
import { Input, InputProps } from '@node-space/storybook-components/dist/Input'
import { Radio, RadioProps } from '@node-space/storybook-components/dist/Radio'
import { TextArea, TextAreaProps } from '@node-space/storybook-components/dist/TextArea'
import { Box, Text } from '@node-space/ui-components'
import { ConfirmValues, DynamicQuestionFieldTypes } from '../helpers/constants'
import { DynamicQuestionMapping } from '../helpers/types'

export interface DynamicQuestionProps {
  code: string
  question: DynamicQuestionMapping
  formField: any
  additionalField?: any
}

export const DynamicQuestion = ({
  code,
  question,
  formField,
  additionalField,
}: DynamicQuestionProps) => {
  const { t } = useTranslation()

  switch (question?.type) {
    case DynamicQuestionFieldTypes.RADIO:
      const radioProps = formField as RadioProps
      return (
        <Box>
          <Radio {...radioProps} hasParagraphLayout horizontal />
          {question?.additionalQuesion && radioProps?.value === ConfirmValues.YES && (
            <Box paddingT={24}>
              <InputLabel forId={code} canWrap>
                {additionalField?.label}
              </InputLabel>
              <TextArea {...additionalField} label="" />
            </Box>
          )}
        </Box>
      )
    case DynamicQuestionFieldTypes.NUMBER:
    case DynamicQuestionFieldTypes.EMAIL:
      const inputProps = formField as InputProps
      return (
        <Box>
          <InputLabel forId={code} canWrap>
            {inputProps?.label}
          </InputLabel>
          <Input {...inputProps} label="" />
        </Box>
      )
    default:
      const textareaProps = formField as TextAreaProps
      return (
        <Box>
          <InputLabel forId={code} canWrap>
            {textareaProps?.label}
          </InputLabel>
          <TextArea {...textareaProps} label="" />
          {question?.helpText && (
            <Text color="subdued" className="mt-1">
              {t(`businessCompliance.helpText.${code}`)}
            </Text>
          )}
        </Box>
      )
  }
}
